import {
  REQUISITION_STATUSES,
  type RequisitionStatus,
} from '@eombor/contracts';
import { Button, cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { Select } from '../../../shared/ui/Select.js';
import { requisitionStatusText } from '../../../shared/i18n/labels.js';

/**
 * Ro'yxat filtri — SO'ROVNING aynan shakli.
 *
 * Uchta maydon `requisitionQuerySchema` da bor va boshqasi YO'Q: sana oralig'i
 * ham, matn qidiruvi ham backendda qabul qilinmaydi. Ekranda mavjud bo'lmagan
 * filtrni ko'rsatish — ishlamaydigan tugma va yo'qolgan ishonch.
 */
export interface RequisitionFilterValue {
  /** `''` — "barcha holatlar" (so'rovga umuman qo'shilmaydi). */
  status: RequisitionStatus | '';
  warehouseId: string;
  mine: boolean;
}

export const EMPTY_REQUISITION_FILTER: RequisitionFilterValue = {
  status: '',
  warehouseId: '',
  mine: false,
};

export const isEmptyFilter = (value: RequisitionFilterValue): boolean =>
  value.status === '' && value.warehouseId === '' && !value.mine;

export interface RequisitionFiltersProps {
  value: RequisitionFilterValue;
  onChange: (value: RequisitionFilterValue) => void;
  warehouses: readonly { id: string; name: string }[];
}

/*
 * O'ROVCHI YO'Q — filtrlar `PageHeader` ning `filters` uyasiga tushadi va
 * guruh yorlig'ini ham, joylashuvni ham o'sha beradi. Ilgari ular sarlavha
 * ostidagi ALOHIDA qatorda turardi: sahifada ikkita boshqaruv qatori bo'lib,
 * ikkinchisi nimaga tegishli ekani ko'rinmasdi.
 */
export const RequisitionFilters = ({
  value,
  onChange,
  warehouses,
}: RequisitionFiltersProps) => (
  <>
    <Select
      variant="filter"
      label={t('requisition.filterStatus')}
      placeholder={t('requisition.filterAllStatuses')}
      value={value.status}
      onChange={(event) =>
        onChange({ ...value, status: event.target.value as RequisitionStatus | '' })
      }
      options={REQUISITION_STATUSES.map((status) => ({
        value: status,
        label: requisitionStatusText(status),
      }))}
    />

    <Select
      variant="filter"
      label={t('requisition.filterWarehouse')}
      placeholder={t('requisition.filterAllWarehouses')}
      value={value.warehouseId}
      onChange={(event) => onChange({ ...value, warehouseId: event.target.value })}
      options={warehouses.map((warehouse) => ({ value: warehouse.id, label: warehouse.name }))}
    />

    <label
      className={cn(
        'flex h-[var(--size-control-md)] items-center gap-2 rounded-[var(--radius-sm)]',
        'border border-border-control px-3 text-sm text-text',
      )}
    >
      <input
        type="checkbox"
        className="size-4 accent-[var(--color-accent)]"
        checked={value.mine}
        onChange={(event) => onChange({ ...value, mine: event.target.checked })}
      />
      {t('requisition.filterMine')}
    </label>

    <Button
      variant="ghost"
      disabled={isEmptyFilter(value)}
      onClick={() => onChange(EMPTY_REQUISITION_FILTER)}
    >
      {t('requisition.filterReset')}
    </Button>
  </>
);
